import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Values = () => {
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Header />
      <section className="relative" style={{}}>
        <div className="container">
          <div className="">
            <img
              className="bg-blue absolute inset-0 h-full w-full object-cover object-center"
              src={require("../assets/images/background2.jpg")}
              alt="Associative image"
            />
            <div
              className="pointer-events-none absolute left-0 top-0 h-full w-full"
              style={{
                background:
                  "linear-gradient(180deg, rgba(17, 23, 41, 0.6) 0%, rgba(32, 41, 58, 0.1) 100%)",
              }}
            ></div>
            <div className="relative flex min-h-[27rem] items-center md:min-h-[25.5rem]">
              <div className="items-center flex w-full flex-col">
                <h1 className="uppercase font-oswald break-words text-5xl md:text-4xl font-medium mb-4 text-white text-center">
                  Mission, Vision, Values
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-gray-100 py-16 md:py-24" style={{}}>
        <div className="container">
          <div className="">
            <div className="mx-auto max-w-[54.5rem] text-center md:text-2xl">
              <div className="font-poppins text-wrap text-lg">
                <p className="space-x-2">
                  <strong className="mr-2">Our mission</strong>
                  is
                  <strong></strong>
                  to create a more advanced world by integrating IoT
                  technologies into people's daily lives.
                </p>
                <p>
                  <br />
                </p>
                <p className="space-x-2">
                  <strong className="mr-2">Our vision</strong>
                  is to become a global leader in the IoT field, inspiring
                  people to innovate, scale their businesses, and change lives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="my-16 md:my-24" style={{}}>
        <div className="container">
          <div className="">
            <div className="space-y-6 md:space-y-12">
              <h2 className="uppercase font-oswald break-words text-5xl md:text-3xl font-medium text-center text-blue-800">
                We pursue our mission guided by these values:
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="bg-gray-200 group flex flex-col justify-between overflow-hidden rounded-lg duration-200">
                  <div className="flex h-full flex-col">
                    <div className="flex flex-1 flex-col gap-y-2 px-6 pb-4 pt-8 md:px-12 md:pb-6 md:pt-12">
                      <div className="uppercase font-oswald break-words text-xl font-medium text-center">
                        Flexibility
                      </div>
                      <p className="font-inter break-words text-sm font-normal text-center">
                        We are always ready to change and adapt to new
                        circumstances. We not only seek solutions but also
                        explore opportunities that inspire new ideas and provide
                        value to our customers.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-200 group flex flex-col justify-between overflow-hidden rounded-lg duration-200">
                  <div className="flex h-full flex-col">
                    <div className="flex flex-1 flex-col gap-y-2 px-6 pb-4 pt-8 md:px-12 md:pb-6 md:pt-12">
                      <div className="uppercase font-oswald break-words text-xl font-medium text-center">
                        Integrity
                      </div>
                      <p className="font-inter break-words text-sm font-normal text-center">
                        We believe that true strength is found in honesty and
                        trust. We don't just talk but deliver on our promises,
                        and we listen to every word with sincere care.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-200 group flex flex-col justify-between overflow-hidden rounded-lg duration-200">
                  <div className="flex h-full flex-col">
                    <div className="flex flex-1 flex-col gap-y-2 px-6 pb-4 pt-8 md:px-12 md:pb-6 md:pt-12">
                      <div className="uppercase font-oswald break-words text-xl font-medium text-center">
                        Courage for change
                      </div>
                      <p className="font-inter break-words text-sm font-normal text-center">
                        Change is the fuel for our growth! We are not afraid to
                        take risks, try again, and take unexplored paths: that's
                        how we find new and unique solutions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-200 group flex flex-col justify-between overflow-hidden rounded-lg duration-200">
                  <div className="flex h-full flex-col">
                    <div className="flex flex-1 flex-col gap-y-2 px-6 pb-4 pt-8 md:px-12 md:pb-6 md:pt-12">
                      <div className="uppercase font-oswald break-words text-xl font-medium text-center">
                        Partnership
                      </div>
                      <p className="font-inter break-words text-sm font-normal text-center">
                        We build empowering connections. Our synergy with
                        partners and within our team enables us to achieve more
                        together, from hearing the needs to delivering real
                        results.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default Values;
